export const handlePasteImage = (event, callback) => {
    const items = event.clipboardData.items;
    for (const item of items) {
        if (item.type.indexOf("image") === 0) {
            const file = item.getAsFile();
            const reader = new FileReader();
            reader.onload = (e) => {
                if (callback) {
                    callback(e.target.result);
                }
            };
            reader.readAsDataURL(file);
        }
    }
};

export const formatImageBase64 = (image) => {
    return image.replace(/^data:image\/(png|jpeg|jpg);base64,/, "");
};
